import { render, staticRenderFns } from "./BrickSettingsAudience.vue?vue&type=template&id=3ef72a33&scoped=true&"
import script from "./BrickSettingsAudience.vue?vue&type=script&lang=js&"
export * from "./BrickSettingsAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef72a33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ef72a33')) {
      api.createRecord('3ef72a33', component.options)
    } else {
      api.reload('3ef72a33', component.options)
    }
    module.hot.accept("./BrickSettingsAudience.vue?vue&type=template&id=3ef72a33&scoped=true&", function () {
      api.rerender('3ef72a33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/BrickSettings/Audience/BrickSettingsAudience.vue"
export default component.exports